import { createSlice } from "@reduxjs/toolkit";

const modalAttachmentSlice = createSlice({
  name: 'modalAttachment',
  initialState: {
    open: false,
    content: {}
  },
  reducers: {
    openModalAttachment: (state, action) => {
      state.open = true;
      state.content = action.payload;
    },
    closeModalAttachment: (state) => {
      state.open = false;
      state.content = [];
    },
  },
})

export const selectStateModalAtt = (state: any) => state.trackingApp.modalAttachment;

export const { openModalAttachment, closeModalAttachment } = modalAttachmentSlice.actions;

export default modalAttachmentSlice.reducer;
